/**
 * Muestra párrafos de metadatos solo si contienen valor dinámico 
 * (más allá del texto dentro del <strong>).
 */
const showIfHasContent = () => {
  const selectors = ['.product-designer', '.product-needle-size'];
  
  selectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    
    elements.forEach(p => {
      const strong = p.querySelector('strong');
      if (strong) {
        const totalText = p.textContent.trim();
        const labelText = strong.textContent.trim();

        // LÓGICA INVERTIDA:
        // Si el texto total es más largo que el label, significa que hay valor.
        if (totalText.length > labelText.length) {
          p.style.setProperty('display', 'flex', 'important');
        } else {
          p.style.setProperty('display', 'none', 'important');
        }
      }
    });
  });
};

// Configuración del Observer para cambios dinámicos (variantes)
const observer = new MutationObserver((mutations) => {
  hideEmptyMetadata(); // Ejecuta la función al detectar cambios
});

document.addEventListener('DOMContentLoaded', () => {
  // 1. Ejecución inmediata al cargar
  showIfHasContent();

  // 2. Observar cambios en el contenedor de información del producto
  const targetNode = document.querySelector('.product__info-container') || document.body;
  
  const config = { 
    childList: true, 
    subtree: true, 
    characterData: true 
  };

  if (targetNode) {
    const observer = new MutationObserver(showIfHasContent);
    observer.observe(targetNode, config);
  }
});


document.addEventListener('DOMContentLoaded', function() {
  // 1. Buscamos todos los elementos de párrafo (p) dentro del contenedor de tabs
  const tabPanels = document.querySelectorAll('.product-tabs__panel .rte p');

  tabPanels.forEach(p => {
    const text = p.textContent.trim();
    
    // 2. Si la línea termina en ":" y no tiene nada después, o está vacía
    // Ejemplo: "Needle Size: "
    if (text.endsWith(':') || text === '') {
      p.style.display = 'none';
    }
  });
});

/**
 * Formatea la composición de los productos para que cada porcentaje
 * comience en una nueva línea.
 */
const formatCompositions = () => {
  const selectors = ['.card-composition', '.product-composition'];
  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      if (!el.dataset.formatted) {
        el.innerHTML = el.innerHTML.replace(/\s+(?=\d+)/g, '<br>');
        el.dataset.formatted = 'true';
      }
    });
  });
};

document.addEventListener('DOMContentLoaded', formatCompositions);

// También observamos cambios para cuando se cargan productos dinámicamente
const compositionObserver = new MutationObserver(formatCompositions);
compositionObserver.observe(document.body, { childList: true, subtree: true });







document.addEventListener('DOMContentLoaded', function () {
  const input = document.querySelector('input[type="search"]');
  const results = document.querySelector('[data-predictive-search]');

  if (!input || !results) return;

  input.addEventListener('input', function () {
    if (input.value.trim() === '') {
      // 🔥 limpiar resultados cuando está vacío
      results.innerHTML = '';
      return;
    }

    // 🔁 forzar actualización
    const event = new Event('keyup', { bubbles: true });
    input.dispatchEvent(event);
  });
});

// 1. Seleccionamos estrictamente los textos dentro de los ítems de la lista de filtros
const labels = document.querySelectorAll('.facets__item .facet-checkbox__text-label');

// 2. Recorremos cada uno de los elementos encontrados
labels.forEach(label => {
    let textoActual = label.textContent;
    
    // 3. Verificamos si el texto contiene el guion "-"
    if (textoActual.includes('-')) {
        // 4. Dividimos el texto usando el guion y nos quedamos con la primera parte [0]
        // Usamos trim() por si queda algún espacio en blanco al final
        label.textContent = textoActual.split('-')[0].trim();
    }
});